<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="power-ii">
<h1 style="font-family:Arial; letter-spacing:1px; font-size:26pt; padding-top:75px; padding-bottom:45px;">POWER II</h1>
<p style="text-align: center;"><em>And Now, The Essence of My Power.</em></p>
<p style="text-align: right;">-<em>Vaul Impera</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?185f7084